var map = {
	"./tarot-card-0.jpg": 1541,
	"./tarot-card-1.jpg": 1542,
	"./tarot-card-10.jpg": 1543,
	"./tarot-card-11.jpg": 1544,
	"./tarot-card-12.jpg": 1545,
	"./tarot-card-13.jpg": 1546,
	"./tarot-card-14.jpg": 1547,
	"./tarot-card-2.jpg": 1548,
	"./tarot-card-3.jpg": 1549,
	"./tarot-card-4.jpg": 1550,
	"./tarot-card-5.jpg": 1551,
	"./tarot-card-6.jpg": 1552,
	"./tarot-card-7.jpg": 1553,
	"./tarot-card-8.jpg": 1554,
	"./tarot-card-9.jpg": 1555
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards ^\.\/tarot\-card\-.*\.jpg$
// module id = 56
// module chunks = 0